const data = [
  {
    id: 1,
    image: "Assets/new1.jpg",
  },
  {
    id: 2,
    image: "Assets/new2.jpg",
  },
  {
    id: 3,
    image: "Assets/new3.jpg",
  },
  {
    id: 4,
    image: "Assets/new4.jpg",
  },
  {
    id: 5,
    image: "Assets/new5.jpg",
  },
  {
    id: 6,
    image: "Assets/download1.jpeg",
  },
  {
    id: 7,
    image: "Assets/download2.jpeg",
  },
  {
    id: 8,
    image: "Assets/download3.jpeg",
  },
  {
    id: 9,
    image: "Assets/download4.jpeg",
  },
  {
    id: 10,
    image: "Assets/download5.jpeg",
  },
  {
    id: 11,
    image: "Assets/download7.jpeg",
  },
  {
    id: 12,
    image: "Assets/download8.jpeg",
  },
  {
    id: 13,
    image: "Assets/download9.jpeg",
  },
  {
    id: 14,
    image: "Assets/download10.jpeg",
  },
  {
    id: 15,
    image: "Assets/download11.jpeg",
  },
  {
    id: 16,
    image: "Assets/download12.jpeg",
  },
];
export default data;
